import { ReactNode } from 'react'
import { StyleCard } from './style'
interface ICard {
  children?: ReactNode
  customStyle?: any
  radius?: number
  pressable?: boolean
  disabled?: boolean
  bg?: string
  onClick?: () => void
  outline?: boolean
}
const Card = ({
  children,

  ...restProps
}: ICard) => {
  return (
    <>
      <StyleCard {...restProps}>{children}</StyleCard>
    </>
  )
}

export default Card
